var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "history__wrapper-purple": _vm.view == "purple" } },
    [
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "col-sm-12 col-lg-8 m-auto" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h1", { staticClass: "h3" }, [
                _vm._v(_vm._s(_vm._f("trans")("st_public.search_history")))
              ])
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm._l(_vm.results, function(result) {
                  return _c(
                    "div",
                    { key: result.id, staticClass: "row person" },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row border border-bottom-0 py-4 bg-white"
                          },
                          [
                            _c("div", { staticClass: "col-sm-8" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-none d-sm-block text-muted font-weight-bold"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("trans")("st_public.search_query")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "h1",
                                { staticClass: "h5" },
                                [
                                  result.matches > 0
                                    ? _c(
                                        "nuxt-link",
                                        {
                                          class:
                                            "text-primary " +
                                            result.search_type,
                                          style:
                                            "direction:" +
                                            (result.search_type == "phone"
                                              ? "ltr"
                                              : ""),
                                          attrs: {
                                            to: {
                                              name:
                                                "lang-search-results-type-search",
                                              params: {
                                                lang: _vm.lang,
                                                search: result.search_keyword,
                                                type: result.search_type
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(result.search_keyword) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  result.matches == 0
                                    ? _c(
                                        "span",
                                        {
                                          class:
                                            "text-primary " +
                                            result.search_type,
                                          style:
                                            "direction:" +
                                            (result.search_type == "phone"
                                              ? "ltr"
                                              : "")
                                        },
                                        [
                                          _vm._v(
                                            "\n                                              " +
                                              _vm._s(result.search_keyword) +
                                              "\n                                          "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _c("div", { staticClass: "col-sm-4" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "d-sm-block mr-2 text-muted font-weight-bold"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("trans")("st_public.date"))
                                  )
                                ]
                              ),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(result.created_at) +
                                  "\n                "
                              )
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                }),
                _c("div", { staticClass: "row border-top" })
              ],
              2
            )
          ])
        ])
      ]),
      _vm.loading ? _c("div", { staticClass: "loading-page" }) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a1b6cd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a1b6cd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/member/search-history.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4a1b6cd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/_lang/member/search-history.vue
// module chunks = 37